// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b91cc02a]:export{primaryColor:#007a59;primaryLightColor:#1cb9fd;secondaryColor:#fdba12;accentColor:#96ff73;textColor:#333}", ""]);
// Exports
module.exports = exports;
